import { HelpCircle } from 'lucide-react';
import React, { useState } from 'react';
import UploadFile from 'src/components/upload-file/upload-file';
import { useUploadInvoiceValidationFileMutation } from 'src/redux/billing/billing.endpoints';

interface ValidateUploadContainerProps {
  invoiceGroupId: string;
  onValidate?: () => void;
  onUpload?: () => void;
}

const ValidateUploadContainer: React.FC<ValidateUploadContainerProps> = ({
  invoiceGroupId,
  onValidate,
  onUpload,
}) => {
  const [isValidating, setIsValidating] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [error, setError] = useState<string | null>(null);
  const maxSizeBytes = 25 * 1024 * 1024;

  const [uploadFile, { isLoading: isUploading }] = useUploadInvoiceValidationFileMutation();

  const handleUpload = async(file: File) => {
    try {
      await uploadFile({ file: file, id: invoiceGroupId }).unwrap();
      if (onUpload) {
        onUpload();
      }
    } catch (error) {
      setError(error as string);
    }
  };

  return (
    <div className="p-4 pt-2 bg-gray-201">
      <div className='flex flex-row gap-2 items-start mb-1'>
        <HelpCircle className="h-4 w-4" />
        <p className='text-xs text-gray-600'>
          Upload a CSV file to validate invoice/line item data, use this
          {' '}
          <a
            href="/csv/validate_invoice_template.csv"
            download="validate_invoice_template.csv"
            className='text-blue-500 underline cursor-pointer'
          >
            template
          </a>
          {' '}
          to get started.
        </p>
        <p className='text-xs text-gray-600 font-bold'>
          {'"Source", "Campaign" and "Amount" are required columns.'}
        </p>
      </div>
      <UploadFile
        handleUpload={handleUpload}
        fileTypes={['.csv']}
      />
    </div>
  );
};

export default ValidateUploadContainer;
